<template>
  <div class="home mx-2 " >
       <div class="col-12  mt-8 mx auto">
          <div  class="intestazione col-lg-9 mx-auto mb-10">
     <h1 >Aree di servizio</h1> <br>
     <p class="custom-text"> </p>
          </div>
         <div class="col-md-10 mx-auto ">
    <list-servizi class=""/>
      </div>
      </div>
  </div>
</template>

<script>

// import ComuniDataService from '@/service/ComuniDataService.js'
import listServizi from '@/components/list-servizi.vue'

export default {
  name: 'Home',
  components: {
    listServizi
  },
  methods: {
    set (id) {
      this.$store.dispatch('setComune', id)
      this.$store.dispatch('setTheme', id)
      // set title
      document.title = this.$store.getters.getComune.nome
    },
    clear () {
      this.$store.dispatch('clearStore')
    }
  },
  created () {
    this.set(this.$route.params.cid)
  },
  computed: {
    ComuneStore () { return this.$store.getters.getComune }
  },
  watch: {
    $route: function (newrot, oldrot) {
      console.log(oldrot, ' su home --> ', newrot)
      this.set(newrot.params.cid)
    },
    ComuneStore (newcs, oldcs) {
      console.log(oldcs, ' --> ', newcs)
      // set title
      document.title = newcs.nome
      // redirect if codCatst invalid
      const cc = newcs.codiceCatasto
      if (!cc) {
        this.$router.push({ name: 'NotFound' })
      }
    }
  }

}
</script>
